import React, { createContext, useState, useContext } from 'react';
import { clearLoginPreferences } from '../utils/voicePreferences';

// Create AuthContext to manage auth state
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    const login = () => {
        setIsAuthenticated(true);
        
    };

    const logout = () => {
        localStorage.removeItem('Token');
        localStorage.removeItem('UserId');
        localStorage.removeItem('Facility');
        localStorage.removeItem('BaseUrl');
        clearLoginPreferences();

        setIsAuthenticated(false);
    };

    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

// Custom hook to use the AuthContext
export const useAuth = () => {
    return useContext(AuthContext);
};
